
export default function CategoryBar(){
    return (
        <ul className="category-horizontal">
           <li className="category-name">Music</li>
           <li className="category-name">Coding</li>
           <li className="category-name">Nature</li>
           <li className="category-name">Health</li>
           <li className="category-name">Short Movie</li>
        </ul>
    )
}